import React from 'react'
import PropTypes from 'prop-types'
import { t } from '@lingui/macro'

import DeviceStoreIcons from '../../../components/DeviceStoreIcons'
import LocalisedImage from '../../../components/common/LocalisedImage'

import yotiIdAppLogo from '../../../../assets/yoti-id-logo.svg'

const AppLinkContent = ({ device }) => (
  <div className="instructions-section__app-link">
    <DeviceStoreIcons device={device} />
    <LocalisedImage className="yoti-logo" alt={t`Yoti Logo`} src={yotiIdAppLogo} />
  </div>
)

AppLinkContent.propTypes = {
  device: PropTypes.objectOf(PropTypes.any).isRequired
}

export default AppLinkContent
